import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueFormCustomFields', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/issue_forms/fragments/custom_fields/custom_fields.html'),
        controller: 'CustomFieldsFormController',
        controllerAs: 'CustomFieldsFormCtrl',
        bindings: {
            isFullWidth: '<', // boolean
            customFields: '=',
            filledCustomFields: '<',
            client: '<',
            companyId: '<',
            userType: '<',
            errors: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/custom_fields/custom_fields.component.ts